import { RegisterOptions } from 'react-hook-form';

import {
  FileInput, Input, Radio, Select, TextArea,
} from 'components';
import { Datepicker } from 'components/Datepicker';
import Checkbox from 'components/checkboxes/default';
import { ContentRoutes } from 'enums/routes';
import { TrainingTypes } from 'enums/types';
import masks from 'utils/masks';

import {
  containerForm,
  materialForm,
  regionalForm,
  userForm,
  companyForm,
  partnerForm,
  projectForm,
  vehicleForm,
  accessoryTypeForm,
  vehicleAccessoryForm,
  driverForm,
  trainingForm,
  userTrainingForm,
  roleTrainingForm,
  driverTrainingForm,
  qrCodeForm,
  companiesForm,
  superUserForm,
} from './forms';

export const inputs = {
  select: Select,
  radio: Radio,
  text: Input,
  image: FileInput,
  checkbox: Checkbox,
  textarea: TextArea,
  date: Datepicker,
};

export const labels = {
  [ContentRoutes.Users]: 'Usuário',
  [ContentRoutes.Regionals]: 'Regional',
  [ContentRoutes.Company]: 'Empresa',
  [ContentRoutes.Project]: 'Projeto',
  [ContentRoutes.Partner]: 'Parceiro',
  [ContentRoutes.Materials]: 'Material',
  [ContentRoutes.Vehicles]: 'Veículo',
  [ContentRoutes.AccessoryTypes]: 'Acessório',
  [ContentRoutes.VehicleAccessories]: 'Acessório Veicular',
  [ContentRoutes.Drivers]: 'Condutor',
  [ContentRoutes.Trainings]: 'Treinamento',
  [ContentRoutes.Companies]: 'Empresa',
  [ContentRoutes.QRCode]: 'QrCode',
  [ContentRoutes.SuperUsers]: 'Super Usuário',
  [ContentRoutes.Containers]: 'Embalagem',
  [TrainingTypes.Role]: 'por Permissão',
  [TrainingTypes.Driver]: 'por Condutor',
  [TrainingTypes.User]: 'por Usuário',
};

export type BaseInputType = {
    name: string
    isMultiple?: boolean
    type: keyof typeof inputs | 'array'
    mask?: keyof typeof masks
    hidden?: [string, Comparators, string]
    required: boolean
    rules?: RegisterOptions
    onChange?: (
        _e: React.ChangeEvent<HTMLInputElement>,
        _setValue: (_key: string, _value: any) => void,
        _getValues?: (_key: string) => any,
        _setError?: (_key: string, _error: any) => any,
        _clearErrors?: (_keys: string[]) => any
        ) => void,
    props?: {
        placeholder?: string
        label?:string
        loadOptions?: any
    } & any
}
export type InputType = BaseInputType & {
    type: keyof typeof inputs | 'array'
    fields?: BaseInputType[]
}

export type FormType = {
    createFn?: (_data: any) => any
    updateFn?: (_data: any) => any
    cancelText?: string
    submitText?: string
    disableText?: string
    enableText?: string
    successText?: string
    fields: InputType[][]
}

export const forms: {[key:string]: FormType} = {
  [ContentRoutes.Users]: userForm,
  [ContentRoutes.Regionals]: regionalForm,
  [ContentRoutes.Containers]: containerForm,
  [ContentRoutes.Materials]: materialForm,
  [ContentRoutes.Company]: companyForm,
  [ContentRoutes.Partner]: partnerForm,
  [ContentRoutes.Project]: projectForm,
  [ContentRoutes.Vehicles]: vehicleForm,
  [ContentRoutes.AccessoryTypes]: accessoryTypeForm,
  [ContentRoutes.VehicleAccessories]: vehicleAccessoryForm,
  [ContentRoutes.Drivers]: driverForm,
  [ContentRoutes.Trainings]: trainingForm,
  [TrainingTypes.User]: userTrainingForm,
  [TrainingTypes.Role]: roleTrainingForm,
  [TrainingTypes.Driver]: driverTrainingForm,
  [ContentRoutes.QRCode]: qrCodeForm,
  [ContentRoutes.Companies]: companiesForm,
  [ContentRoutes.SuperUsers]: superUserForm,
};
